import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "length",
    "uppercaseLetterNumber",
    "submit",
    "input",
    "toggle",
  ];

  connect() {
    if (
      this.hasLengthTarget &&
      this.hasUppercaseLetterNumberTarget &&
      this.hasSubmitTarget
    ) {
      this.validatePassword();
    }
    // If show/hide targets exist, set up toggle text
    if (this.hasInputTarget && this.hasToggleTarget) {
      this.updateToggleText();
    }
  }

  input(event) {
    this.password = event.target.value;
  }

  set password(value) {
    this.data.set("password", value);
    this.validatePassword();
  }

  get password() {
    if (!this.data.has("password")) {
      this.password = "";
    }
    return this.data.get("password");
  }

  validatePassword() {
    // Only run if validation targets exist
    if (
      !(
        this.hasLengthTarget &&
        this.hasUppercaseLetterNumberTarget &&
        this.hasSubmitTarget
      )
    )
      return;
    let valid = true;
    // Validate presence of numbers and capital letters
    let regex = /(?=.*[A-Z])(?=.*\d)/g;
    if (this.password.match(regex)) {
      this.uppercaseLetterNumberTarget.classList.toggle("invalid", false);
    } else {
      this.uppercaseLetterNumberTarget.classList.toggle("invalid", true);
      valid = false;
    }
    // Validate length
    if (this.password.length >= 8) {
      this.lengthTarget.classList.toggle("invalid", false);
    } else {
      this.lengthTarget.classList.toggle("invalid", true);
      valid = false;
    }
    // Enable/Disable submission
    this.submitTarget.disabled = !valid;
  }

  toggle() {
    if (!(this.hasInputTarget && this.hasToggleTarget)) return;
    const input = this.inputTarget;
    input.type = input.type === "password" ? "text" : "password";
    this.updateToggleText();
    this.toggleTarget.setAttribute("aria-pressed", input.type === "text");
  }

  updateToggleText() {
    if (!(this.hasInputTarget && this.hasToggleTarget)) return;
    this.toggleTarget.textContent =
      this.inputTarget.type === "password" ? "Show password" : "Hide password";
  }
}
